module.exports = __webpack_public_path__ + "img/020_artemis_thb.cdc52146.jpg";